<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">应用服务日志</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="开始时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
              :tooltip-effect="light"
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" :formatter="formatDate" width="180"></el-table-column>
              <el-table-column prop="serverIp" label="IP" width="160"></el-table-column>
              <el-table-column prop="event" label="事件">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="事件" width="250" trigger="hover">
                    <div>{{scope.row.event}}</div>
                    <span
                      slot="reference"
                    >{{ scope.row.event && scope.row.event.length>20?scope.row.event.substr(0,20)+'...':scope.row.event }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="details" label="详情">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="详情" width="300" trigger="hover">
                    <div>{{scope.row.details}}</div>
                    <span
                      slot="reference"
                    >{{ scope.row.details && scope.row.details.length>20?scope.row.details.substr(0,20)+'...':scope.row.details }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "AppServerLogList",
  controller: "UI",
  action: "AppServerLogList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      startTime: new Date().format("yyyy-MM-dd 00:00:00"),
      endTime: new Date().format("yyyy-MM-dd 23:59:59")
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        startTime: this.startTime,
        endTime: this.endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      MyApis.AppServerLogApi.listAppServerLog(searchInfo)
        .then(r => {
          this.tableData = r.rows || [];
          this.total = r.total || 0;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e && e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/systemLog/ui/AppServerLogDetail",
        query: { InfoId: row.id }
      });
    },
    // 点击查询按钮
    onSearch() {
      if (this.endTime && this.startTime && new Date(this.endTime) < new Date(this.startTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.startTime = new Date().format("yyyy-MM-dd 00:00:00");
      this.endTime = new Date().format("yyyy-MM-dd 23:59:59");
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data === "" || data === "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>
<style lang="css">
.el-popover {
  background: #00407b !important;
}
</style>
